export const CREATE_SEGMAP = 'CREATE_SEGMAP'
export const SAVED_SEGMAP = 'SAVED_SEGMAP'
export const EDIT_SEGMAP = 'EDIT_SEGMAP'
export const EDITED_SEGMAP = 'EDITED_SEGMAP'
export const FETCH_SEGMAP = 'FETCH_SEGMAP'
export const FETCHED_SEGMAP = 'FETCHED_SEGMAP'
export const SEARCH_SEGMAP = 'SEARCH_SEGMAP'
export const STORE_SEARCH_SEGMAP_RESULT = 'STORE_SEARCH_SEGMAP_RESULT'
export const DELETE_SEGMAP = 'DELETE_SEGMAP'
export const DELETED_SEGMAP = 'DELETED_SEGMAP'
export const NOTIFICATION_DONE_SEGMAP = 'NOTIFICATION_DONE_SEGMAP'
export const FILTER_ITEMS = 'FILTER_ITEMS'
export const GET_COMPANY_DETAILS = 'GET_COMPANY_DETAILS'
export const SAVED_COMPANY_DETAILS = 'SAVED_COMPANY_DETAILS'

